<template>
  <div class="change-previous-stage-link" @click="$emit('click')">
    <v-icon color="primary" small>arrow_left</v-icon>
    Change outcome from the previous {{ previousStage }} stage
  </div>
</template>

<script>
export default {
  name: 'ChangePreviousStageLink',
  props: {
    previousStage: {
      type: String,
      required: true,
    },
  },
  emits: ['click'],
};
</script>

<style lang="scss" scoped>
.change-previous-stage-link {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;

  font-size: 10px;
  font-weight: 300;
  color: var(--v-primary-base);
  cursor: pointer;
}
</style>
